import FadeInSection from '../../../components/feature/FadeInSection';

export default function ReasonClosingSection() {
  return (
    <section className="section-padding" style={{ background: '#fffaf6' }}>
      <div className="content-width">
        <FadeInSection>
          <div className="max-w-2xl mx-auto text-center">
            {/* Label */}
            <p
              className="inline-block px-5 py-1.5 rounded-full text-sm font-bold mb-5"
              style={{ background: '#fff0e6', color: '#8b4513', border: '1px solid #d4a574' }}
            >
              最後に
            </p>

            {/* Section title */}
            <h2
              className="mb-10"
              style={{
                color: '#4a3728',
                fontSize: 'clamp(24px, 3vw, 36px)',
                fontWeight: '700',
                lineHeight: '1.5',
              }}
            >
              ご縁を、ともに。
            </h2>

            {/* Decorative line */}
            <div className="flex items-center justify-center gap-4 mb-10">
              <div className="h-px w-16" style={{ background: 'linear-gradient(to right, transparent, #d4a574)' }} />
              <div className="flex items-center justify-center w-8 h-8">
                <i className="ri-heart-2-line text-xl" style={{ color: '#e8934e' }}></i>
              </div>
              <div className="h-px w-16" style={{ background: 'linear-gradient(to left, transparent, #d4a574)' }} />
            </div>

            {/* Main message */}
            <p
              className="mb-8 leading-relaxed"
              style={{
                color: '#4a3728',
                fontSize: 'clamp(17px, 2vw, 21px)',
                fontWeight: '500',
                lineHeight: '2',
              }}
            >
              和ははは、ただお相手を探す場所ではなく、<br />
              <strong style={{ color: '#1a1a1a', fontWeight: '700' }}>
                安心して一歩を踏み出せる場所でありたい
              </strong>
              と考えています。
            </p>

            {/* Sub message */}
            <p
              className="mb-10"
              style={{
                color: '#6b5a4e',
                fontSize: 'clamp(15px, 1.6vw, 18px)',
                lineHeight: '2.2',
              }}
            >
              一人では不安なことも、<br />
              一緒であれば前に進める。
            </p>

            {/* Closing line */}
            <p
              style={{
                color: '#6b5a4e',
                fontSize: 'clamp(15px, 1.6vw, 18px)',
                fontWeight: '400',
                lineHeight: '2',
              }}
            >
              そんなご縁づくりを、これからも大切にしてまいります。
            </p>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
